import React, { useEffect,useState  } from "react";
import Slider from "../components/Slider";
import BlogCard from "../components/BlogCard";
import "./Home.css";
import { Datacontext } from "../context/Datacontext";
import { useContext } from "react";
import { Spinner } from "react-bootstrap";
import useAutoScroll from "../hooks/useAutoScroll";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";


import { featured } from "../data/featured";
// import { blogs } from "../data/blogs";
// import { magazines } from "../data/magazines";


const scrollByAmount = (selector, amount) => {
  const el = document.querySelector(selector);
  if (!el) return;

  el.dispatchEvent(new Event("mousedown")); // pause auto-scroll

  el.scrollBy({
    left: amount,
    behavior: "smooth",
  });
};





const Home = () => {
  useAutoScroll(".featured-auto", 0.5, 16);
  useAutoScroll(".blogs-auto", 0.6, 16);
  useAutoScroll(".magazines-auto", 0.5, 16);
  const { magazines, blogs,highlights, loading, refetch } = useContext(Datacontext);
  const [subscribeMessage, setSubscribeMessage] = useState("");
  const handleSubscribe = async (e) => {
  e.preventDefault();

  const email = e.target.email.value;

  try {
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/subscribers/subscribe`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    const data = await res.json();

    if (res.ok) {
      setSubscribeMessage("Subscribed successfully!");
      e.target.reset();
    } else {
      setSubscribeMessage(data.message || "Subscription failed");
    }
  } catch (error) {
    setSubscribeMessage("Something went wrong!");
  }
};


  useEffect(() => {
    if (refetch) refetch();
  }, [refetch]);

  useEffect(() => {
    const els = document.querySelectorAll(".fade-up");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => e.isIntersecting && e.target.classList.add("visible"));
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="home">
      <Slider />

      {/* ABOUT */}
      <section className="section-container fade-up">
        <h2 className="section-title">About the Author</h2>
        <div className="author-wrapper">
          <div className="author-text">
            <h3>Prof. (Dr) Mallikarjuna Rao Dubisetty</h3>
            {/* <p>
              Visionary academician, healthcare leader and social reform advocate
              with 27+ years of experience across healthcare, education and
              digital transformation.
            </p> */}
            <p>
              Doctoral Research Scholar, Education, Research, Healthcare & IT Leadership with Dual MBA-Telecom | Hospital & Health Systems Management from BITS Pilani. Versatile & Multi-Faceted professional with 27+ Years Exp, Cross geo's Client Management, Certified PM & Expert Architect, Strategist. Winner of State Govt, National & International, Project Mgmt awards, Author, International Recognised Speaker in TEDx, International Patient Safety & National Healthcare Conference, NABIDH, CSR Leader, Academic Ambassador, Autism Intervention/Rehabilitation Specialist. Ex IBM, Accenture, Apollo Hospitals, FHPL, NISC & NIIT.
            </p>
          </div>
        </div>
      </section>

      {/* FEATURED */}
      <section className="section-container fade-up">
        <h2 className="section-title">Featured Highlights</h2>

        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" size="sm" />
            <p className="text-muted mt-2">Loading...</p>
          </div>
        ) : (
        <div className="scroll-wrapper">
          <button
            className="scroll-btn left"
            onClick={() => scrollByAmount(".featured-auto", -300)}
          >
            ‹
          </button>

          <div className="horizontal-scroll featured-auto">
          
                      {highlights
  .filter((highlight) => highlight.is_published === 1)
  .map((highlight) => (
              <a
                key={highlight.id}
                href={highlight.link}
                target="_blank"
                rel="noopener noreferrer"
                className="featured-scroll-card"
              >
                <img                   src={`${process.env.REACT_APP_BACKEND_URL}${highlight.image}`}
 alt={highlight.title} className="featured-scroll-img" />
                <h3>{highlight.title}</h3>
              </a>
            ))}
          </div>

          <button
            className="scroll-btn right"
            onClick={() => scrollByAmount(".featured-auto", 300)}
          >
            ›
          </button>
        </div>
        )}
      </section>

      {/* BLOGS */}
      <section className="section-container fade-up">
        <h2 className="section-title">Recent Blogs</h2>

        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" size="sm" />
            <p className="text-muted mt-2">Loading...</p>
          </div>
        ) : (
        <div className="scroll-wrapper">
          <button
            className="scroll-btn left"
            onClick={() => scrollByAmount(".blogs-auto", -300)}
          >
            ‹
          </button>

          <div className="horizontal-scroll blogs-auto">
                 {blogs
  .filter((blog) => blog.is_published === 1)
  .slice(0,5)
  .map((blog) => (
              <BlogCard key={blog.id} blog={blog} />
            ))}
          </div>

          <button
            className="scroll-btn right"
            onClick={() => scrollByAmount(".blogs-auto", 300)}
          >
            ›
          </button>
        </div>
        )}
      </section>

      {/* MAGAZINES */}
      <section className="section-container fade-up">
        <h2 className="section-title">Recent Magazines</h2>

        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" variant="primary" size="sm" />
            <p className="text-muted mt-2">Loading...</p>
          </div>
        ) : (
        <div className="scroll-wrapper">
          <button
            className="scroll-btn left"
            onClick={() => scrollByAmount(".magazines-auto", -300)}
          >
            ‹
          </button>

          <div className="horizontal-scroll magazines-auto">
               {magazines
  .filter((mag) => mag.is_published === 1)
  .slice(0,5)
  .map((mag) => (
              <Link
                key={mag.id}
                to={`/reader/${mag.id}`}
                className="magazine-card"
              >
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}${mag.cover_image}`}
                  alt={mag.title}
                />
                <p className="magazine-title">{mag.title}</p>
                <p>{mag.description}</p>
              </Link>
            ))}
          </div>


          <button
            className="scroll-btn right"
            onClick={() => scrollByAmount(".magazines-auto", 300)}
          >
            ›
          </button>
        </div>
        )}
      </section>

      {/* GET IN TOUCH / SUBSCRIBE */}
{/* KEEP IN TOUCH */}
<section className="subscribe-section fade-up">
  <div className="subscribe-container">
    
    <h2 className="subscribe-title">KEEP IN TOUCH</h2>

    <p className="subscribe-text">
      Join our newsletter to receive exclusive content and updates about
      blogs, magazines and highlights.
    </p>

<form className="subscribe-form" onSubmit={handleSubscribe}>
  <div className="input-group">
    <input
      type="email"
      name="email"
      placeholder="Enter Email Address"
      required
    />
    <button type="submit">
      {subscribeMessage ? subscribeMessage : "Add me to the list"}
    </button>
  </div>
</form>

   

    

  </div>
</section>
    </div>
  );
};

export default Home;
